import * as Types from '@crimeos-frontend/crime-os/graphql';

import { gql } from '@apollo/client';
import { FilterFragmentDoc } from './FilterFragment.generatedTypes';
export type SectionFragment = { __typename: 'Section', sectionId: string, sectionName: string, defaultIcon: string, sectionType: Types.SectionType, sectionDescription: string, selectedIcon: string, recordCreationName?: string | null, templateSelection?: { __typename: 'SectionTemplateSelection', placeholder: string, label: string } | null, noRecordsView: { __typename: 'SectionNoRecordsView', title: string, description: string }, filtersConfig: Array<{ __typename: 'Filter', filterId: string, name: string, isMultiSelectOption: boolean, filterOptions: Array<{ __typename: 'FilterOption', name: string, id: string }> }>, orderedSectionTemplates: Array<{ __typename: 'SectionTemplate', canHaveMultipleRecords: boolean, iconUrl: string, templateId: string, previewFields: Array<{ __typename: 'PreviewField', fieldId: string, hideIfEmpty: boolean }> }> };

export const SectionFragmentDoc = gql`
    fragment Section on Section {
  sectionId
  sectionName
  defaultIcon
  sectionType
  sectionDescription
  selectedIcon
  recordCreationName
  templateSelection {
    placeholder
    label
  }
  noRecordsView {
    title
    description
  }
  filtersConfig {
    ...Filter
  }
  orderedSectionTemplates {
    canHaveMultipleRecords
    iconUrl
    previewFields {
      fieldId
      hideIfEmpty
    }
    templateId
  }
}
    ${FilterFragmentDoc}`;